/**
 * @generated SignedSource<<74fe7b4be0d209ad31b61219746d91a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LibraryQuery$variables = {};
export type LibraryQuery$data = {
  readonly music_viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"LibraryRows_musicViewer">;
  };
};
export type LibraryQuery = {
  variables: LibraryQuery$variables;
  response: LibraryQuery$data;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LibraryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LibraryRows_musicViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LibraryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "pieces",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "378920577bfd802a895601606e6dc3e4",
    "id": null,
    "metadata": {},
    "name": "LibraryQuery",
    "operationKind": "query",
    "text": "query LibraryQuery {\n  music_viewer {\n    ...LibraryRows_musicViewer\n  }\n}\n\nfragment LibraryRow_piece on MusicPiece {\n  id\n  name\n}\n\nfragment LibraryRows_musicViewer on MusicViewer {\n  pieces {\n    id\n    ...LibraryRow_piece\n  }\n}\n"
  }
};

(node as any).hash = "cb9cc27bcba57524d101ba485790084e";

export default node;
